import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "reminderToggle"]

  connect() {
    // Close on escape key
    this.boundHandleEscape = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.boundHandleEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleEscape)
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()

    // Find the modal by ID (since the button and modal are separate)
    const modal = document.getElementById("streak-modal")
    if (modal) {
      modal.classList.remove("hidden")
      document.body.style.overflow = "hidden"

      // Reinitialize lucide icons for the modal
      if (window.lucide) {
        window.lucide.createIcons()
      }
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    // If called from the modal's controller, use this.element
    // Otherwise find by ID
    const modal = this.element.id === "streak-modal" ? this.element : document.getElementById("streak-modal")
    if (modal) {
      modal.classList.add("hidden")
      document.body.style.overflow = ""
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  handleEscape(event) {
    const modal = document.getElementById("streak-modal")
    if (event.key === "Escape" && modal && !modal.classList.contains("hidden")) {
      this.close()
    }
  }

  async toggleReminder(event) {
    const button = event.currentTarget
    const toggleKnob = button.querySelector("span")
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch("/streak/toggle_reminder", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        }
      })

      const data = await response.json()

      if (data.success) {
        // Update toggle appearance
        if (data.reminder_enabled) {
          button.classList.remove("bg-gray-200")
          button.classList.add("bg-orange-500")
          toggleKnob.classList.remove("translate-x-1")
          toggleKnob.classList.add("translate-x-6")
        } else {
          button.classList.remove("bg-orange-500")
          button.classList.add("bg-gray-200")
          toggleKnob.classList.remove("translate-x-6")
          toggleKnob.classList.add("translate-x-1")
        }
      }
    } catch (error) {
      console.error("Error toggling reminder:", error)
    }
  }
}
